import React from "react";

import { CircularProgress, Container, Stack } from "@mui/material";
import { Grid } from "@mui/system";

import { clusterHasPsData } from "../../utils";
import Fsk8sBanner from "./Banner";
import Fsk8sPageBannerNoData from "./BannerNoData";
import ClusterCostChart from "./ClusterCostChart";
import { Fsk8sOverviewDashboard } from "./OverviewDashboard";
import { Fsk8sClusterTable } from "./Table";
import { useClusterDashboardContext } from "./Table/context";

const Fsk8sPageContent = () => {
  const { dashboardClusters, initialLoading } = useClusterDashboardContext();

  const hasClusterWithData = React.useMemo(
    () => dashboardClusters.clusters.some((c) => clusterHasPsData(c)),
    [dashboardClusters]
  );

  if (initialLoading) {
    return (
      <Container
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "75vh",
        }}
      >
        <CircularProgress />
      </Container>
    );
  }

  if (!hasClusterWithData) {
    return <Fsk8sPageBannerNoData />;
  }

  return (
    <Stack spacing={2}>
      <Stack spacing={3}>
        <Fsk8sOverviewDashboard />
        <Grid container spacing={2}>
          <Grid
            size={{
              xs: 12,
              md: 6,
            }}
          >
            <ClusterCostChart />
          </Grid>
          <Grid
            size={{
              xs: 12,
              md: 6,
            }}
          >
            <Fsk8sBanner />
          </Grid>
        </Grid>
        <Fsk8sClusterTable />
      </Stack>
    </Stack>
  );
};

export default Fsk8sPageContent;
